import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  ListItemRadioButton,
  type ListItemRadioButtonProps,
} from '@wix/da-ds/pkg/List/ListItem';
import { type SubNavigation } from '../../../../../../types/store';

import s from './ShopFiltersStatusRadioGroup.scss';

export interface Props extends Pick<ListItemRadioButtonProps, 'onChange'> {
  status: SubNavigation;
  currentFilterValue: string;
  className?: string;
}

const ShopFiltersStatusRadioGroup: React.FC<Props> = ({
  className,
  status: statusSubnavs,
  currentFilterValue,
  onChange,
}) => {
  const { t } = useTranslation();

  return (
    <fieldset
      className={className}
      role="radiogroup"
      aria-labelledby="shop-filters-status"
    >
      <p id="shop-filters-status">
        {t('shopPage.shopFiltersForm.status.legend')}
      </p>

      {statusSubnavs.options?.map(({ subnav }) => {
        return (
          <ListItemRadioButton
            key={`${subnav}`}
            className={s['radio-button']}
            name="saleType"
            label={t(`shopPage.shopFiltersForm.status.label.${subnav}`)}
            value={subnav}
            checked={subnav === currentFilterValue}
            onChange={onChange}
          />
        );
      })}
    </fieldset>
  );
};

ShopFiltersStatusRadioGroup.displayName = 'ShopFiltersStatusRadioGroup';
export default ShopFiltersStatusRadioGroup;
